/**
 * 集計表(report-table)の並べ替えできる見出し(設計書 §4-4: 操作は <button>、現在の列に aria-sort)。
 * 並べ替えの状態は呼び出し側(tableTools の useSort)が持つ。業務ロジックは持たない。
 */
import type { CSSProperties, ReactNode } from 'react';
import HelpTip, { type Help } from '@core/components/HelpTip';
import { IconSort, IconSortAsc, IconSortDesc } from '@core/components/icons';
import type { SortDir, SortState } from '@core/components/tableTools';

export default function SortableTh<K extends string>({
  label,
  sortKey,
  sort,
  onSort,
  defaultDir = 'desc',
  help,
  numeric = false,
  className,
  style,
  rowSpan,
  colSpan,
}: {
  label: ReactNode;
  sortKey?: K;
  sort?: SortState<K>;
  onSort?: (key: K, defaultDir?: SortDir) => void;
  defaultDir?: SortDir;
  /** 見出しにカーソルを合わせたときの説明 */
  help?: Help;
  numeric?: boolean;
  className?: string;
  style?: CSSProperties;
  rowSpan?: number;
  colSpan?: number;
}) {
  const active = !!sort && !!sortKey && sort.key === sortKey;
  const cls = [numeric ? 'is-num' : '', className ?? ''].filter(Boolean).join(' ') || undefined;
  const text = help ? <HelpTip help={help}>{label}</HelpTip> : label;
  return (
    <th scope="col" className={cls} style={style} rowSpan={rowSpan} colSpan={colSpan} aria-sort={sortKey ? (active ? (sort!.dir === 'asc' ? 'ascending' : 'descending') : 'none') : undefined}>
      {sortKey && onSort ? (
        <button type="button" className={`dt-sort${active ? ' is-active' : ''}`} onClick={() => onSort(sortKey, defaultDir)}>
          <span>{text}</span>
          {active ? sort!.dir === 'asc' ? <IconSortAsc size={14} /> : <IconSortDesc size={14} /> : <IconSort size={14} />}
        </button>
      ) : (
        text
      )}
    </th>
  );
}
